import type React from 'react';
import Link from 'components/Globals/Base/Link';
import type { MenuItemProps } from 'interfaces/navigation/Header';
import HUBPAGE_TEST_IDS from 'constants/testsIds/hubpage';
import * as S from './SubSectionNavStyles';

export interface SubSectionHubProps {
  subMenu?: MenuItemProps[];
}

const SubSectionNav: React.FC<SubSectionHubProps> = ({ subMenu }) => {
  let navData;

  if (subMenu) {
    navData = subMenu.map((subSections) => ({
      link: subSections.url,
      name: subSections.label,
      slug: subSections.url,
    }));
  }

  return (
    <S.Wrapper data-cy={HUBPAGE_TEST_IDS.SUBSECTION_NAV}>
      {navData?.map((subSections) => (
        <S.Item key={subSections.slug}>
          <Link
            key={subSections.slug}
            href={subSections.link}
          >
            {subSections.name}
          </Link>
        </S.Item>
      ))}
    </S.Wrapper>
  );
};

export default SubSectionNav;
